import { render, staticRenderFns } from "./AddPPM_daily.vue?vue&type=template&id=f5405724&scoped=true"
import script from "./AddPPM_daily.vue?vue&type=script&lang=ts"
export * from "./AddPPM_daily.vue?vue&type=script&lang=ts"
import style0 from "./AddPPM_daily.vue?vue&type=style&index=0&id=f5405724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5405724",
  null
  
)

export default component.exports